import React from 'react'

export default (props) => {
    // const icon = `fab fa-${props.icon}`;

    return (
        <a href={props.link} className="contact__icon" target="_blank">
            <i className={props.icon}></i>
        </a>
    )
}



// WEBPACK FOOTER //
// ./src/components/ContactItem.js